import { z } from 'zod';

export const COOKIE_PREFIX = '\\(O.O)/_';

const staticCookieNameSchema = z.union([
  z.literal('access_token'),
  z.literal('refresh_token'),
  z.literal('token_expired_date'),
  z.literal('locale'),
  z.literal('tab'),
  z.literal('last_used_workspace_id'),
  z.literal('deviceId'),
  z.literal('workspaces_label_ids'),
  z.literal('fetch_options'),
  z.literal('audit_log_fetch_options'),
  z.literal('upload_options'),
  z.literal('password_forgot_disable'),
  z.literal('2fa_email_verify_disable'),
  z.literal('invite_workspace_disable'),
  z.literal('email_verify_signup_disable'),
  z.literal('email_verify_set_pw_disable'),
  z.literal('instant_event_disable'),
  z.literal('search_workspace_disable'),
  z.literal('signup_email_disable'),
  z.literal('login_email_disable'),
  z.literal('share_auth_disable'),
  z.literal('redirect_url'),
]);

// workspace slug를 동적으로 포함해야하는 쿠키
const workspaceTokenRegex = /^w_[a-z0-9]+_chat_(access|refresh)_token$/;
export const dynamicWorkspaceSchema = z.string().regex(workspaceTokenRegex);

export const cookieNameSchema = z.union([staticCookieNameSchema, dynamicWorkspaceSchema]);

type StaticCookieName = z.infer<typeof staticCookieNameSchema>;
type WorkspaceCookieName = `w_${string}_chat_${'access' | 'refresh'}_token`;

export type CookieName = StaticCookieName | WorkspaceCookieName;
